export const iconFontAwesomeHumanitarianSheetPlastic = (
	<i className="fa-solid fa-sheet-plastic"></i>
);
